export default __webpack_public_path__ + "static/media/DISTINTIOV_ESR.1e7b7a06.png";